// customerAccountsAPI.ts
import axios from "axios";
import { store } from "../../../redux/store";
import { AppDispatch } from "../../../redux/store";
import {
  setAccountSearchOptions,
  setCurrentPage,
  setHasMore,
  setIsScroll,
  setOrganizationSearchOptions,
  setRepCodeSearchOptions,
} from "../../../redux/reducers/OTISReducer";


type Option = {
  label: string;
  value: string;
};


export const fetchCustomerAccounts = async (
  searchTerm?: string,
  DISTRIBUTION_CHANNEL?: any,
  Org?: any,
  Account?: any,
  page?: any,
  dispatch?: AppDispatch,
  setLoadingTest?: (loading: boolean) => void,
  LoadingTest?: boolean,
) => {



  if (LoadingTest) return;
  setLoadingTest?.(true);


  let data: any = {};
  let flag = false;
  data.page = page;
  if (DISTRIBUTION_CHANNEL) {
    data.DISTRIBUTION_CHANNEL = DISTRIBUTION_CHANNEL;
    flag = true;
  }
  if (Org) {
    data.Org = Org;
    flag = true;
  }
  if (Account) {
    data.Account = Account;
    flag = true;
  }
  if (searchTerm) {
    data.searchTerm = searchTerm;
    if (dispatch) dispatch(setCurrentPage(1));
    data.page = 1;
    flag = true;
  }


  const currentState = store.getState();
  const isScroll = currentState.OTISReducer.isScroll;

  if (isScroll) {
    flag = false;
  }

  try {
    const response = await axios.post("accounts/fetchCustomerAccounts", data);

    if (flag) {
      // Replace
      const repOptions = response.data.uniquedistribution.map((dist: any) => ({
        label: dist.value === null ? dist.label : dist.value, // Use DISTRIBUTION_CHANNEL (dist.label) if DISTRIBUTION_CHANNEL_NAME (dist.value) is null
        value: dist.label,
      }));
      const orgOptions = response.data.uniqueOrganizations.map((org: any) => ({
        label: org.value,
        value: org.label,
      }));
      const accountOptions = response.data.uniqueAccounts.map((account: any) => ({
        label: account.value,
        value: account.label,
      }));

      if (dispatch) {
        dispatch(setRepCodeSearchOptions(repOptions));
        dispatch(setOrganizationSearchOptions(orgOptions));
        dispatch(setAccountSearchOptions(accountOptions));

      } else {
        return {
          repOptions,
          orgOptions,
          accountOptions,
          pagination: response.data.pagination,
        };
      }
    } else {
      // Append with deduplication by value
      const rawRepOptions = response.data.uniquedistribution.map((dist: any) => ({
        label: dist.value === null ? dist.label : dist.value,
        value: dist.label,
      }));
      const rawOrgOptions = response.data.uniqueOrganizations.map((org: any) => ({
        label: org.value,
        value: org.label,
      }));
      const rawAccountOptions = response.data.uniqueAccounts.map((account: any) => ({
        label: account.value,
        value: account.label,
      }));

      if (dispatch) {
        const currentState = store.getState();
        const existingReps: Option[] = currentState.OTISReducer.repCodeSearchOptions || [];
        const existingOrgs: Option[] = currentState.OTISReducer.organizationSearchOptions || [];
        const existingAccounts: Option[] = currentState.OTISReducer.accountSearchOptions || [];

        // Filter out duplicates based on value
        const newRepOptions = rawRepOptions.filter(
          (item: any) => !existingReps.some(existing => existing?.value === item.value)
        );
        const newOrgOptions = rawOrgOptions.filter(
          (item: any) => !existingOrgs.some(existing => existing?.value === item.value)
        );
        const newAccountOptions = rawAccountOptions.filter(
          (item: any) => !existingAccounts.some(existing => existing?.value === item.value)
        );

        dispatch(setRepCodeSearchOptions([...existingReps, ...newRepOptions]));
        dispatch(setOrganizationSearchOptions([...existingOrgs, ...newOrgOptions]));
        dispatch(setAccountSearchOptions([...existingAccounts, ...newAccountOptions]));
        
        dispatch(setIsScroll(false));

      } else {
        
        return {
          
          repOptions: rawRepOptions,
          orgOptions: rawOrgOptions,
          accountOptions: rawAccountOptions,
          pagination: response.data.pagination,
        };
      }
    }

    setLoadingTest?.(false);
    dispatch?.(setIsScroll(false));

    // document.body.style.overflow = "auto";

    dispatch?.(setHasMore(
      response.data.pagination?.currentPage <
      response.data.pagination?.totalPages
    ));

    return response.data;
  } catch (error) {
    console.error("Error fetching customer accounts:", error);
    setLoadingTest?.(false);
    // document.body.style.overflow = "auto";

    throw error;
  }
};
